import moment from 'moment';
import {StatisticsBinning} from '../../backend/enums/statistics-binning';
import {MomentLanguageCode} from '../../enums/moment-language-code';

const customFormat: {[key in MomentLanguageCode]: string} = {
  [MomentLanguageCode.enGB]: 'MMM D',
  [MomentLanguageCode.ptPT]: 'D MMM',
  [MomentLanguageCode.esES]: 'D MMM',
  [MomentLanguageCode.glES]: 'D MMM',
  [MomentLanguageCode.ptBR]: 'D MMM',
};

/**
 * Get the x label for a chart of the statistics dashboards given the month, year, binning, and day.
 *
 * Note: The month index in moment is from 0 (january) to 11 (december).
 */
export const getXLabelStatisticsDashboardChart = (
  month: number,
  year: number,
  binning: StatisticsBinning,
  day?: number
): string => {
  return binning === StatisticsBinning.Month
    ? `${moment().month(month).format('MMM')} ${moment().year(year).format('YYYY')}`
    : `${moment(`${year}-${month + 1}-${day}`).format(customFormat[moment.locale() as MomentLanguageCode])}`;
};
